/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';

import { N20, N40A, N50A } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ProfilePlacesList = styled.div`
	padding: ${token('space.100', '8px')};
	border-radius: ${token('border.radius.100', '3px')};
	background: ${token('color.background.neutral', N20)};

	> div {
		margin-bottom: ${token('space.100', '8px')};
	}

	> div:last-child {
		margin-bottom: 0;
	}
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const EmptyPlacesList = styled.div`
	padding: ${token('space.200', '16px')} ${token('space.100', '8px')};
	border-radius: ${token('border.radius.100', '3px')};
	box-shadow: ${token('elevation.shadow.raised', `0 1px 1px ${N50A}, 0 0 1px 1px ${N40A}`)};

	> div {
		margin-bottom: ${token('space.100', '8px')};
	}

	> div:last-child {
		margin-bottom: 0;
	}
`;
